// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__xXZri","inner":"Footer_inner__O++ya","links":"Footer_links__xCME4"};